import http from './http.service';

class DashboardService {
    constructor() {
        if (DashboardService.instance) {
            return DashboardService.instance;
        }

        DashboardService.instance = this;
    }

    groups() {
        return http.get('/dashboard').then(res => res.data);
    }
    groupVehicles(slug) {
        return http.get(`/dashboard/${slug}/group-vehicles`).then(res => res.data);
    }
    reorderBookings(vehicles) {
        return http.post('/dashboard/reorder-bookings', vehicles).then(res => res.data);
    }
}

export default new DashboardService();
